import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './Header.css';
import ProductList from './ProductList';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Header() {

    const [selectedCategory, setSelectedCategory] = useState('전체');
    const [searchTerm, setSearchTerm] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [sessionValid, setSessionValid] = useState(null);

    const history = useHistory();

    useEffect(() => {
        // console.log('api: ', API_BASE_URL);
        // console.log('API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);

        const urlParams = new URLSearchParams(window.location.search);
        const name = urlParams.get('name');
        const session = urlParams.get('session');

        // console.log(name);
        // console.log(session);

        if (name) {
            setCustomerName(name);
        }
        
        const checkSession = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/cart/auth/check?session=${session}&name=${name}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
    
                });
                // console.log(response)
                if (response.ok) {
                    const result = await response.json();
                    // console.log(result)
                    if (result) {
                        setSessionValid(true);
                    } else {
                        setSessionValid(false);
                    }
                } 
                else {
                    setSessionValid(false);
                }
            } catch (error) {
                console.error('Error checking session:', error);
                setSessionValid(false);
            }
        };

        checkSession();
    }, [history]);

    //false이면 denied page로
    useEffect(() => {
        if (sessionValid === false) {
            history.push('/denied');
        }
    }, [sessionValid, history]);

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        setSearchTerm(''); // 카테고리 버튼 누르면 검색어 초기화 (검색 종료)
    };

    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            setSearchTerm(e.target.value);
            setSelectedCategory('전체');
        }
    };

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
        setSelectedCategory('전체');
    };

    if (sessionValid === null) {
        return null; // 세션인증결과 받기전까진 아무것도 렌더링하지 않음
    }

    return (
        <div className="head-container"> 
            <header className="header">
                <div className="top-section">
                    <img src="/logo.png" alt="Cleanier Snack" className="logo" />
                    <input type="text" placeholder="상품명검색" className="search-bar" 
                    value={searchTerm}
                    onChange={handleInputChange}
                    />
                </div>
                <div className="info-section">
                    <div className="info-text">
                        <img src="/building.png" alt="Cleanier Snack" className="info-logo" />
                        <div>
                            <p className="info-title">{customerName || "고객 공간명이 들어갑니다"}</p>
                            <p>안녕하세요. 클리니어 스낵 매대에 채워질 상품을 골라주세요!</p>
                        </div>
                    </div>
                </div>
                <nav className="category-nav">
                    {[
                        { label: "전체", image: "/whole.png" },
                        { label: "봉지 스낵", image: "/bagSnack.png" },
                        { label: "갑 스낵", image: "/boxSnack.png" },
                        { label: "쿠키/파이", image: "/cookiePie.png" },
                        { label: "젤리/초콜릿", image: "/jellyChocolate.png" },
                        { label: "견과류/에너지바", image: "/nuts.png" },
                        { label: "음료", image: "/drink.png" },
                        { label: "우유/두유", image: "/milk.png" },
                        { label: "차/티백/커피", image: "/tea.png" },
                        { label: "시리얼/컵라면", image: "/cereal.png" }
                    ].map((category, index) => (
                        <CategoryButton 
                            key={index}
                            label={category.label}
                            image={category.image}
                            selected={selectedCategory === category.label}
                            onClick={() => handleCategoryClick(category.label)}
                        />
                    ))}
                </nav>
            </header>
            <ProductList selectedCategory={selectedCategory} searchTerm={searchTerm}/> 
        </div>
    );
}

function CategoryButton({ label, image, selected, onClick }) {
    const isAllProducts = label === "전체";

    return (
        <button 
            className={`category-button ${selected ? 'selected' : ''} ${isAllProducts ? 'all-products' : ''}`} 
            onClick={onClick}
        >
            {isAllProducts ? (
                <div className="all-products-content">
                    <img src={image} alt={label} className="category-image all-products-image" />
                    <span className="category-label all-products-label">{label}</span>
                </div>
            ) : (
                <>
                    <span className="category-label">{label}</span>
                    <img src={image} alt={label} className="category-image" />
                </>
            )}
        </button>
    );
}

export default Header;
